import React, { useState } from "react";
import "../elements/LoginForm.css";
import { FaUser, FaEnvelope, FaPhone, FaHouseUser } from "react-icons/fa";
import axios from "axios";
import ErrorModal from "../elements/ErrorModal";
import TermsModal from "../elements/TermsModal";
import PopUpModal from "../elements/PopUpModal";
import { Link } from "react-router-dom";

function Registration() {
  const API_URL = process.env.REACT_APP_API_URL;

  const [userFullName, setUserFullName] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [companyPib, setCompanyPib] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyLocation, setCompanyLocation] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyActivity, setCompanyActivity] = useState("");
  const [companyEmployeeNum, setCompanyEmployeeNum] = useState("");
  const [isInvalidPib, setIsInvalidPib] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [errorLog, setErrorLog] = useState(null);
  const [modalPopUp, setModalPopUp] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const resetForm = () => {
    setUserFullName("");
    setUserPhone("");
    setUserEmail("");
    setCompanyPib("");
    setCompanyName("");
    setCompanyLocation("");
    setCompanyAddress("");
    setCompanyActivity("");
    setCompanyEmployeeNum("");
    setTermsAccepted(false);
    setErrorLog(null);
  };

  const triggerBlink = () => {
    setIsInvalidPib(false);
    setTimeout(() => setIsInvalidPib(true), 20);
  };

  const handleApiCallForPib = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/Login/Korisnik/VratiNBSKlijenta`,
        { params: { companyPib } }
      );
      if (response.status === 200 && response.data != null) {
        setCompanyName(response.data.Naziv);
        setCompanyLocation(response.data.Mesto);
        setCompanyAddress(response.data.Adresa);
        setIsInvalidPib(false);
      } else {
        setCompanyName("");
        setCompanyLocation("");
        setCompanyAddress("");
        triggerBlink();
      }
    } catch {
      setCompanyName("");
      setCompanyLocation("");
      setCompanyAddress("");
      triggerBlink();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!termsAccepted) {
      setErrorLog("Niste prihvatili uslove korišćenja");
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.post(
        `${API_URL}/Login/Korisnik/Registracija`,
        {
          userFullName,
          userEmail,
          userPhone,
          companyPib,
          companyName,
          companyLocation,
          companyAddress,
          companyActivity,
          companyEmployeeNum,
        }
      );
      if (response.status === 200) {
        setModalPopUp("Uspešno poslat zahtev za registraciju.");
        resetForm();
      }
    } catch (error) {
      if (error.response?.status === 400) {
        const msg =
          error.response.data?.Message || error.response.data || "Greška.";
        setErrorLog(msg);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-layout auth-layout--panel-right">

      {/* ===== REGISTRATION FORMA (levo) ===== */}
      <div className="auth-form-side auth-form--left auth-form-side--scroll">
        <h2 className="title">Registraciona forma</h2>

        <form onSubmit={handleSubmit}>
          <div className="input-field-reg">
            <FaUser className="icon-login" />
            <input
              type="text"
              placeholder="Ime i prezime"
              value={userFullName}
              onChange={(e) => setUserFullName(e.target.value)}
              required
            />
          </div>

          <div className="input-field-reg">
            <FaEnvelope className="icon-login" />
            <input
              type="text"
              placeholder="E-mail"
              value={userEmail}
              onChange={(e) => setUserEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-field-reg">
            <FaPhone className="icon-login" />
            <input
              type="text"
              placeholder="Telefon"
              value={userPhone}
              onChange={(e) => setUserPhone(e.target.value)}
              required
            />
          </div>

          <div className={`input-field-reg ${isInvalidPib ? "blink" : ""}`}>
            <FaHouseUser className="icon-login" />
            <input
              type="text"
              placeholder="PIB"
              value={companyPib}
              onChange={(e) => setCompanyPib(e.target.value)}
              onBlur={handleApiCallForPib}
              required
            />
          </div>

          <div className={`input-field-reg ${isInvalidPib ? "blink" : ""}`}>
            <FaHouseUser className="icon-login" />
            <input
              type="text"
              placeholder="Naziv firme"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              required
            />
          </div>

          <div className={`input-field-reg ${isInvalidPib ? "blink" : ""}`}>
            <FaHouseUser className="icon-login" />
            <input
              type="text"
              placeholder="Mesto"
              value={companyLocation}
              onChange={(e) => setCompanyLocation(e.target.value)}
              required
            />
          </div>

          <div className={`input-field-reg ${isInvalidPib ? "blink" : ""}`}>
            <FaHouseUser className="icon-login" />
            <input
              type="text"
              placeholder="Adresa"
              value={companyAddress}
              onChange={(e) => setCompanyAddress(e.target.value)}
              required
            />
          </div>

          <div className="input-field-reg">
            <FaHouseUser className="icon-login" />
            <input
              type="text"
              placeholder="Delatnost"
              value={companyActivity}
              onChange={(e) => setCompanyActivity(e.target.value)}
            />
          </div>

          <div className="input-field-reg">
            <FaHouseUser className="icon-login" />
            <input
              type="text"
              placeholder="Broj zaposlenih"
              value={companyEmployeeNum}
              onChange={(e) => setCompanyEmployeeNum(e.target.value)}
            />
          </div>

          <div className="terms-row">
            <input
              type="checkbox"
              id="terms-checkbox"
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
            />
            <label htmlFor="terms-checkbox">
              Slažem se sa uslovima korišćenja
            </label>
          </div>

          <div className="prezentacija-actions">
            <input
              type="submit"
              value="Pošalji"
              className="btn-login"
              disabled={isLoading}
            />
            <button
              type="button"
              className="btn-login"
              onClick={() => setShowTermsModal(true)}
            >
              Uslovi korišćenja
            </button>
          </div>
        </form>
      </div>

      {/* ===== ORANGE PANEL (desno) ===== */}
      <div className="auth-panel auth-panel--right">
        <div>
          <h2>Već imate nalog?</h2>
          <p>
            Ukoliko imate korisničko ime i lozinku, kliknite ispod da pređete
            na stranicu za logovanje.
          </p>
        </div>
        <Link to="/login" className="btn-panel">
          Logovanje
        </Link>
        <img
          src="/poslovni-softver/img/registration.svg"
          className="auth-panel-img"
          alt="Registracija ilustracija"
          loading="lazy"
        />
      </div>

      {errorLog && (
        <ErrorModal message={errorLog} onClose={() => setErrorLog(null)} />
      )}
      {modalPopUp && (
        <PopUpModal message={modalPopUp} onClose={() => setModalPopUp(null)} />
      )}
      {showTermsModal && (
        <TermsModal onClose={() => setShowTermsModal(false)} />
      )}
    </div>
  );
}

export default Registration;
